const cities = [
    {
      id: 1,
      title: "Jakarta",
    },
    {
      id: 2,
      title: "Seoul",
    },
    {
      id: 3,
      title: "Tokyo",
    },
    {
      id: 4,
      title: "London",
    },
    {
      id: 5,
      title: "New York",
    },
  ];

export default cities;
